import "./css/organizationPanel.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../common/store/combinedReducer";
import { useEffect, useRef, useState } from "react";
import {
  getOrgStatus,
  setActivePage,
  setLoading,
  setOrgDropDown,
  setSelectedPlant,
  setSelectedTenant,
  setSignalR,
  setSiteID,
  setVMData,
  setVmIdNotification,
  settabledata,
  setAssignedStatus,
  setUserRoleStatus,
  setAssignedRoles,
  removeSelectedVM,
  getAssignedRoles,
  getUserRoles,
  setSelectedView,
  setSelectedClusterData,
} from "../../../store/action";
import { REQUIRED_PERMISSIONS } from "../../../../common/authentication/config";
import _ from "lodash";
import { HubConnection, HubConnectionState } from "@microsoft/signalr";
import config from "../../../../common/authentication/config";
import { customToast } from "../../../../App";
import {
  closeConnection,
  setParams,
  setUpSignalRConnection,
} from "../../../../common/utility/Dashboard/utility";
import SearchableSelectDropDown from "../../../../common/components/SearchableSelectDropDown";
import PlantDetails from "./plantDetails";
// import NewPlantDetails from "./newPlantDetails";

const OrganizationPanel = (props: any) => {
  const dispatch = useDispatch();
  let connection: HubConnection;
  const word = "...";
  const index: any = localStorage.getItem("index") || 0;
  const activePage = useSelector((state: AppState) => {
    return state.reducer.activePage;
  });
  const orgData = useSelector((state: AppState) => {
    return state.reducer.orgData;
  });
  const orgsDropDownData = useSelector((state: AppState) => {
    return state.reducer.orgsDropDownData;
  });
  const selectedPlant = useSelector((state: AppState) => {
    return state.reducer.selectedPlant;
  });
  const orgDataStatus = useSelector((state: AppState) => {
    return state.reducer.orgDataStatus;
  });

  const permissions = useSelector((state: AppState) => {
    return state.reducer.permissions;
  });
  const signalRConnection = useSelector((state: AppState) => {
    return state.reducer.signalR;
  });
  const tenantDropDownData = useSelector((state: AppState) => {
    return state.reducer.tenantDropDownData;
  });
  const selectedTenantIndex = useSelector((state: AppState) => {
    return state.reducer.selectedTenantIndex;
  });
  const clusterData = useSelector((state: AppState) => {
    return state.reducer.clusterData;
  });
  const selectedTenant = useSelector((state: AppState) => {
    return state.reducer.selectedTenant;
  });
  const [selectedCluster, setSelectedCluster] = useState<any[] | undefined>(
    undefined,
  );
  const isHonAcaTenant = selectedTenant === config.ACADEMY_TENANT_ID;
  const [selectedOrg, setSelectedOrg] = useState(selectedPlant);
  const [dom, setDom] = useState(false);
  const [signalrConnection, setSignalrConnection] =
    useState<HubConnection>(signalRConnection);
  const [showUserManagement, setShowUserManagement] = useState(false);
  const [showDataManagement, setShowDataManagement] = useState(false);
  // const [selectedData, setSelectedData] = useState<any>();
  const filteredData: any = useRef("");
  const [plantSearchTerm, setPlantSearchTerm] = useState("");
  const [tenantSearchTerm, setTenantSearchTerm] = useState("");
  const [clusterSearchTerm, setClusterSearchTerm] = useState("");
  const [defaultCluster, setDefaultCluster] = useState<any>();
  const [nodeFilterResetKey, setNodeFilterResetKey] = useState(0);
  useEffect(() => {
    setSelectedOrg(selectedPlant);
    const valuePermission: any = _.find(permissions, [
      "resources",
      selectedPlant,
    ]);
    // setSelectedData(valuePermission);
    if (valuePermission && valuePermission?.permissions.length > 0) {
      const hasUserManagement =
        REQUIRED_PERMISSIONS.CAN_VIEW_USER_MANAGEMENT.every((p: string) =>
          valuePermission.permissions.includes(p),
        );
      const hasDataManagement =
        REQUIRED_PERMISSIONS.TRANSFER_DATA_OR_FILES_IN_AND_OUT.every(
          (p: string) => valuePermission.permissions.includes(p),
        );
      if (hasUserManagement) setShowUserManagement(true);
      if (hasDataManagement) setShowDataManagement(true);
    }
  }, [orgsDropDownData, orgData]);

  useEffect(() => {
    if (
      signalRConnection === undefined ||
      !signalRConnection ||
      !signalRConnection?.state
    ) {
      dispatch(setSignalR(signalrConnection));
    }
  }, [signalrConnection, signalRConnection]);

  useEffect(() => {
    if (orgDataStatus === 200) {
      dispatch(setVmIdNotification(null));
      if (
        orgData?.some(
          (d: any) => d.siteId === selectedOrg || selectedOrg === "",
        )
      ) {
        setDefaultCluster(
          selectedCluster ?? clusterData.map((data: any) => data.value),
        );
        dispatch(
          setSelectedClusterData(
            selectedCluster ?? clusterData.map((data: any) => data.value),
          ),
        );
      }
      orgData &&
        orgData.length > 0 &&
        orgData.forEach((data: any) => {
          if (
            data &&
            data.siteId === selectedOrg &&
            data.siteId !== config.SITE_ID
          ) {
            dispatch(setSiteID(data.siteId as string));
            if (data.IsVCDAlive === false)
              customToast(
                "This site is not available currently, please try after sometime.",
                "critical",
              );
            if (
              (signalRConnection &&
                signalRConnection.state === HubConnectionState.Disconnected) ||
              signalRConnection === undefined ||
              !signalRConnection ||
              !signalRConnection?.state
            ) {
              // connect only if the signalr is disconnected as it'll create more wss calls
              setUpSignalRConnection(data.name, dispatch, setSignalrConnection);
            }
          } else if (selectedOrg == "" && data.siteId !== config.SITE_ID) {
            if (
              (signalRConnection &&
                signalRConnection.state === HubConnectionState.Disconnected) ||
              signalRConnection === undefined ||
              !signalRConnection ||
              !signalRConnection?.state
            ) {
              // connect only if the signalr is disconnected as it'll create more wss calls
              setUpSignalRConnection(
                orgData && orgData[0]?.name,
                dispatch,
                setSignalrConnection,
              );
            }
          }
        });
    }
    setDom(!dom);
  }, [orgDataStatus, orgData]);

  useEffect(() => {
    window.history.replaceState(
      null,
      "",
      `/dashboard/?siteId=${selectedPlant}&tenantId=${selectedTenant}`,
    );
    setParams(selectedPlant, selectedTenant, "dashboard");
  }, [selectedTenant, selectedPlant]);
  const changeTenantData = (text: any) => {
    closeConnection(signalRConnection, HubConnectionState, dispatch);
    setTenantSearchTerm(""); // Clear tenant search term when option is selected
    const selectedOption = tenantDropDownData?.find(
      (data: any) => data?.text === text,
    );
    const value = selectedOption?.value;
    const index =
      tenantDropDownData?.findIndex((data: any) => data?.value === value) ?? 0;
    dispatch(
      setSelectedTenant({
        selectedTenant: value,
        selectedTenantIndex: index,
      }),
    );
    setNodeFilterResetKey((prev) => prev + 1);
    localStorage.setItem("index", (0).toString());
    setSelectedCluster(undefined);
    dispatch(setOrgDropDown(value));
    // Run the following after setOrgDropDown is completed
    setTimeout(() => {
      if (
        index > -1 &&
        orgsDropDownData?.length > 0 &&
        orgsDropDownData[0].value !== ""
      ) {
        localStorage.setItem("tenantIndex", index.toString());
        dispatch(getOrgStatus(0));
        // dispatch(setActivePage(0));
        dispatch(setLoading(true));
        dispatch(setVMData([]));
        dispatch(settabledata([]));
        dispatch(setAssignedStatus(0));
        dispatch(setUserRoleStatus(0));
        setShowUserManagement(false);
        setShowDataManagement(false);
        dispatch(setAssignedRoles({ data: [] }));
      }
    }, 0);
  };

  const changeOrgData = (text: any) => {
    closeConnection(signalRConnection, HubConnectionState, dispatch);
    setPlantSearchTerm(""); // Clear plant search term when option is selected
    const selectedOption = orgsDropDownData?.find(
      (data: any) => data?.text === text,
    );
    const value = selectedOption?.value;
    const valuePermission = _.find(permissions, ["resources", value]);
    orgsDropDownData?.forEach((data: any, index: any) => {
      if (data && data?.value === value && valuePermission) {
        localStorage.setItem("index", index);
        dispatch(setVMData([]));
        dispatch(settabledata([]));
        dispatch(setLoading(true));
        dispatch(getOrgStatus(0));
        dispatch(setAssignedStatus(0));
        setSelectedOrg(value);
        dispatch(setSelectedPlant(value));
        dispatch(setActivePage(index));
        setNodeFilterResetKey((prev) => prev + 1);
        dispatch(setSiteID(value));
        orgData?.vmDetails?.forEach((element: any) => {
          element.checked = false;
        });
        dispatch(removeSelectedVM());
        setSelectedCluster(undefined);
        const isHonAcaTenant = orgsDropDownData.find(
          (data: any) => data.value === config.SITE_ID,
        );
        const hasUserManagement =
          REQUIRED_PERMISSIONS.CAN_VIEW_USER_MANAGEMENT.every((p: string) =>
            valuePermission.permissions.includes(p),
          );
        const hasDataManagement =
          REQUIRED_PERMISSIONS.TRANSFER_DATA_OR_FILES_IN_AND_OUT.every(
            (p: string) => valuePermission.permissions.includes(p),
          );
        if (hasUserManagement && !isHonAcaTenant) setShowUserManagement(true);
        else setShowUserManagement(false);
        if (hasDataManagement && !isHonAcaTenant) setShowDataManagement(true);
        else setShowDataManagement(false);
      }
    });
  };

  const changeClusterValue = (e: any) => {
    setSelectedCluster(e); // Clear cluster search term when option is selected
    dispatch(setSelectedClusterData(e));
  };

  const sortedClusterData = clusterData?.sort((a: any, b: any) => {
    if (a?.value === config.CLUSTER_DEFAULT) return 1;
    if (b?.value === config.CLUSTER_DEFAULT) return -1;
    return (a?.value || "").localeCompare(b?.value || "", undefined, {
      sensitivity: "base",
    });
  });
  return (
    <div className="new-container-wrapper">
      <div className="new-left-header-wrapper">
        {tenantDropDownData?.length > 0 &&
          orgsDropDownData?.length > 0 &&
          orgsDropDownData[index]?.value !== "" &&
          tenantDropDownData[selectedTenantIndex]?.value !== "" && (
            <div className="new-left-header">
              <SearchableSelectDropDown
                data={tenantDropDownData}
                selectedIndex={selectedTenantIndex}
                searchTerm={tenantSearchTerm}
                placeholder="Select Tenant"
                ariaLabel="Tenant"
                id="manage-tenant-wrapper"
                testId="manage-tenant-wrapper-test"
                className="manage-tenant-select"
                controlClassName="manage-tenant-control"
                onChange={changeTenantData}
                onSearchChange={setTenantSearchTerm}
                onBlur={() => setTenantSearchTerm("")}
              />

              <SearchableSelectDropDown
                data={orgsDropDownData}
                selectedIndex={index}
                searchTerm={plantSearchTerm}
                placeholder="Select Site"
                ariaLabel="Plant"
                id="manage-plant-wrapper"
                testId="manage-plant-wrapper-test"
                className="manage-plant-select"
                controlClassName="manage-plant-control"
                disabled={
                  orgsDropDownData.length === 1 &&
                  orgsDropDownData[0].value === config.SITE_ID
                }
                onChange={changeOrgData}
                onSearchChange={setPlantSearchTerm}
                onBlur={() => setPlantSearchTerm("")}
              />
              {!isHonAcaTenant && (
                <SearchableSelectDropDown
                  key={`cluster-${selectedPlant}-${clusterData.length}`}
                  data={sortedClusterData}
                  // selectedIndex={index}
                  searchTerm={clusterSearchTerm}
                  defaultValue={
                    selectedCluster ??
                    sortedClusterData.map((data: any) => data.value)
                  }
                  placeholder="Select Cluster"
                  ariaLabel="Cluster"
                  id="manage-cluster-wrapper"
                  testId="manage-cluster-wrapper-test"
                  className="manage-cluster-select"
                  controlClassName="manage-cluster-control"
                  onChange={changeClusterValue}
                  onSearchChange={setClusterSearchTerm}
                  // onBlur={() => set("")}
                  multiple
                  canSelectAll={true}
                />
              )}
            </div>
          )}
      </div>
      <PlantDetails
        isHonAcaTenant={isHonAcaTenant}
        nodeFilterResetKey={nodeFilterResetKey}
      />
    </div>
  );
};

export default OrganizationPanel;
